// leaflet.js

/* eslint-disable max-len */

$(document).ready(function() {
  if ( $('#map_canvas').length ) {
    var mymap = L.map('map_canvas').setView([-39.2036975, 174.0560297], 9);

    if (location.hostname.match('biesheuvel.lan')) {
      var url = '//{s}.tile.osm.org/{z}/{x}/{y}.png';
      var myToken = '';
    } else {
      // var url = 'https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}';
      // var myToken = 'pk.eyJ1IjoiZnJvbnRlbmRzdHVkaW8iLCJhIjoiY2prdGphNmN3MDVvczNrcDMxdXY2bjRlNyJ9.xxcBGoypRqqlWMdpCjbqoA';
      var url = '//{s}.tile.osm.org/{z}/{x}/{y}.png';
      var myToken = '';
    }

    L.tileLayer(url, {
      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      maxZoom: 18,
      id: 'mapbox.streets',
      accessToken: myToken,
    }).addTo(mymap);

    var marker = L.marker([-39.2036975, 174.0560297]).addTo(mymap);
    marker.bindPopup('<b>Pouakai Cabins</b>');
  }
});


//
// EOF
//
